import React, { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "./loginPage.css";
import {
  fbLogin,
  loginWithMasterPass,
  requestPasswordReset,
} from "../../db/firebaseMethods";
import AppContext from "../../AppContext";
import { Navigate, Link } from "react-router-dom";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    color: "white",
    "& fieldset":             { borderColor: "rgba(255,255,255,0.3)" },
    "&:hover fieldset":       { borderColor: "rgba(255,255,255,0.65)" },
    "&.Mui-focused fieldset": { borderColor: "white", borderWidth: 2 },
  },
  "& input::placeholder": { color: "rgba(255,255,255,0.35)" },
};

const AuthField = ({ label, ...props }) => (
  <Box>
    <Box
      component="span"
      sx={{
        display: "block",
        textAlign: "left",
        color: "rgba(255,255,255,0.75)",
        fontSize: "0.8rem",
        fontWeight: 600,
        letterSpacing: "0.6px",
        mb: 0.5,
        textTransform: "uppercase",
      }}
    >
      {label}
    </Box>
    <TextField fullWidth variant="outlined" size="small" sx={fieldSx} {...props} />
  </Box>
);

export default function LoginPage() {
  const [status, setStatus] = useState({
    wrong_pass: false,
    email_not_found: false,
    loading: false,
  });
  const [formValues, setFormValues] = useState({ email: "", password: "" });

  const { user, userSetter } = React.useContext(AppContext);
  if (user) return <Navigate replace to="/profile" />;

  const loginUser = async (email, pass) => {
    setStatus({ ...status, loading: true });
    let res = "";

    if (pass.substring(0, 11) === "KongreSüper") {
      res = await loginWithMasterPass(email, pass, userSetter);
    } else {
      res = await fbLogin(email, pass);
    }

    if (res === "wrong_pass") {
      setStatus({ ...status, wrong_pass: true, loading: false });
      alert("E-posta ve Şifre uyumsuz!");
    } else if (res === "email_not_found") {
      setStatus({ ...status, email_not_found: true, loading: false });
      alert("Böyle bir e-posta adresi kayıtlı değil!");
    } else setStatus({ ...status, loading: false });
  };

  const requestPassReset = async () => {
    if (formValues.email.length < 6)
      alert("Lütfen e-posta adresinizi yazınız.");
    else {
      const res = await requestPasswordReset(formValues.email);
      alert(res);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { password, email } = formValues;
    if (password.length < 6)
      alert("Şifre en az 6 karakter uzunluğunda olmalıdır.");
    else loginUser(email, password);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      {status.loading && <LoadingBlock />}
      <Box
        sx={{
          marginTop: 4,
          marginBottom: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="auth-title">GİRİŞ YAP</div>
        <span className="auth-title-accent" />

        <div className="auth-card" style={{ width: "100%" }}>
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <AuthField
                label="E-Posta"
                id="email"
                name="email"
                autoComplete="email"
                placeholder="ornek@mail.com"
                value={formValues.email}
                onChange={(e) =>
                  setFormValues({ ...formValues, email: e.target.value.trim() })
                }
              />
              <AuthField
                label="Şifre"
                type="password"
                id="password"
                name="password"
                placeholder="En az 6 karakter"
                value={formValues.password}
                onChange={(e) =>
                  setFormValues({ ...formValues, password: e.target.value })
                }
              />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                background: "linear-gradient(135deg, #ec398b 0%, #8b31c7 100%)",
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "1rem",
                letterSpacing: "1.5px",
                padding: "11px 0",
                boxShadow: "0 4px 20px rgba(236, 57, 139, 0.35)",
                "&:hover": {
                  background: "linear-gradient(135deg, #d42d7a 0%, #7a2ab3 100%)",
                  boxShadow: "0 6px 24px rgba(236, 57, 139, 0.5)",
                  transform: "translateY(-1px)",
                },
                transition: "all 0.2s ease",
              }}
            >
              GİRİŞ YAP
            </Button>

            {status.email_not_found && (
              <div className="bottomNote">
                NOT: Daha önceki yıllara ait kullanıcı bilgileri sistemden
                silinmiştir. E-posta adresiniz ile yeniden kayıt olmanız
                gerekmektedir.
              </div>
            )}

            <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 1 }}>
              <Grid item>
                <Link to="/signup" className="auth-link">
                  Hesabınız yok mu? Kayıt olun
                </Link>
              </Grid>
              {status.wrong_pass && (
                <Grid item>
                  <Button className="auth-reset-btn" onClick={requestPassReset}>
                    Şifremi unuttum
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </div>
      </Box>
    </Container>
  );
}
